import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import { Box}  from '@mui/material'

import ExerciseVideos from '../components/ExerciseVideos';
import SimilarExercises from '../components/SimilarExercises';
import Detail from '../components/Detail';
import { exerciseOptions, fetchData, youtubeOptions } from '../utils/fetchData';

const ExerciseDetail = () => {
  const [exerciseDetail, setExerciseDetail] = useState({});
  const [exerciseVideos, setExerciseVideos] = useState({})
  const [targetMuscleExercises, setTargetMuscleExercises] = useState([]);
  const [equipmenExercises,  setEquipmenExercises] = useState([]);
  const {id} = useParams();

  useEffect(() =>{
    const fetchExercisesData = async () => {
      const exerciseDbUrl = 'https://exercisedb.p.rapidapi.com';
      const youtubeSearchUrl = 'https://youtube-search-and-download.p.rapidapi.com';

      const exerciseDetailData = await fetchData(`${exerciseDbUrl}/exercises/exercise/${id}`, exerciseOptions);
      setExerciseDetail(exerciseDetailData);

      const exerciseVideosData = await fetchData(`${youtubeSearchUrl}/search?q=${exerciseDetailData.name}`, youtubeOptions);
      setExerciseVideos(exerciseVideosData.contents);
      

      const targetMuscleExerciseData = await fetchData(`${exerciseDbUrl}/exercises/
      target/${exerciseDetailData.target}`, exerciseOptions);
      setTargetMuscleExercises(targetMuscleExerciseData);
      const equipmentExercisesData = await fetchData(`${exerciseDbUrl}/exercises/
      equipment/${exerciseDetailData.equipment}`, exerciseOptions);
      setEquipmenExercises(equipmentExercisesData);

    }
    
    try{fetchExercisesData();}catch(err){
      alert(err)
    }
  }, [id]
  
  );

  return (
    <Box>
      <Detail exerciseDetail={exerciseDetail}/>
      <ExerciseVideos exerciseVideos={exerciseVideos} name={exerciseDetail.name}/>
      <SimilarExercises targetMuscleExercises={targetMuscleExercises} equipmentExercises={equipmenExercises}/>

      </Box>
  )
}

export default ExerciseDetail;